// LeagueMediaMini.js — mini stream / media player for league pages
const LEAGUE_PLAYLISTS = {
  ligaf:    'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  fbl:      'PLx5dBnHxEEAd2RAwnHcBzDGbfZfYfLq8k',
  saf:      'PLx5dBnHxEEAc3gFLCQXMqHwh3JXTmCxJL',
  dam:      'PLx5dBnHxEEAd2RAwnHcBzDGbfZfYfLq8k',
  'a-lea':  'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  usl:      'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  brasil:   'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  we:       'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  bpi:      'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  wk:       'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  gsl:      'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  nwfl:     'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  saff:     'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  jleague:  'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
  ligamxfem:'PLx5dBnHxEEAdM3Rj5t6-nJJlFk0JRYAOE',
};

export class LeagueMediaMini {
  constructor(el, leagueId) {
    this.el  = typeof el === 'string' ? document.getElementById(el) : e
    this.lid = leagueId;
  }

  init() {
    if (!this.el) return;
    const pid = LEAGUE_PLAYLISTS[this.lid];
    this.el.innerHTML = pid ? this._embedHTML(pid) : this._placeholderHTML();
  }

  _embedHTML(playlistId) {
    return `
      <div style="padding:16px 0;">
        <div style="font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;
                    color:var(--text-secondary,#888);padding:0 4px 12px;opacity:.7;">
          📺 League Media
        </div>
        <div style="position:relative;padding-bottom:56.25%;height:0;border-radius:14px;overflow:hidden;
                    box-shadow:0 4px 20px rgba(0,0,0,.12);">
          <iframe
            src="https://www.youtube.com/embed/videoseries?list=${playlistId}&rel=0&modestbranding=1"
            style="position:absolute;inset:0;width:100%;height:100%;border:none;"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen loading="lazy">
        </iframe>
        </div>
        <div style="margin-top:10px;font-size:12px;color:var(--text-secondary,#999);text-align:center;">
          Highlights · Interviews · Match recaps
        </div>
      </div>`;
  }

  _placeholderHTML() {
    return `
      <div style="padding:60px 20px;text-align:center;color:var(--text-secondary,#888);">
        <div style="font-size:40px;margin-bottom:12px;">📺</div>
        <div style="font-weight:600;font-size:15px;margin-bottom:6px;">Media coming soon</div>
        <div style="font-size:13px;">Highlights and match content will appear here.</div>
      </div>`;
  }
}
